<template>
  <div class="precision-setting">
    <el-dialog class="precision-setting-dialog" title="参数设置" :visible.sync="dialogVisible" center :before-close="cancelClick">
      <!--      <div class="precision-setting-item" v-if="isPaper && decryption_id">
        <span class="precision-setting-item-title">版面图来源</span>
        <div class="precision-setting-item-content">
          <div class="accuracy">
            <el-radio v-model="additionalSetting.layoutSource" :label="1">反解文件版面图</el-radio>
            <span class="introduction">解析速度快，版面清晰度取决于反解软件输出结果</span>
          </div>
          <div class="accuracy">
            <el-radio v-model="additionalSetting.layoutSource" :label="0">PDF</el-radio>
            <span class="introduction">解析速度慢，需等待PDF转换，但版面清晰</span>
          </div>
        </div>
      </div>-->
      <div class="precision-setting-item">
        <span class="precision-setting-item-title">当前精度</span>
        <div class="precision-setting-item-content">
          <div class="accuracy">
            <el-radio v-model="additionalSetting.dpi" label="180" :disabled="merge">高清模式</el-radio>
            <span class="introduction">上传速度最快，阅读流畅度最佳</span>
          </div>
          <div class="accuracy">
            <el-radio v-model="additionalSetting.dpi" label="300" :disabled="merge">超清模式</el-radio>
            <span class="introduction">上传速度稍慢于高清，但转化后的清晰度最佳</span>
          </div>
        </div>
      </div>

      <div class="precision-setting-item">
        <div class="precision-setting-item-title vip">
          <span class="sub">展示范围</span>
          <div class="sub vip-sub"><span class="vip-normal">VIP</span></div>
        </div>
        <div class="precision-setting-item-content">
          <div class="accuracy"><el-radio @change="getAllCursor" v-model="zsfw" :label="1">全部展示</el-radio></div>
          <div class="accuracy">
            <el-radio v-model="zsfw" @change="zsfwRadioHandler" :label="0">部分展示</el-radio>
            展示到第
            <el-input-number
              @change="radiosanbai"
              @blur="onInputBlur"
              v-model="zswfPage"
              :min="1"
              ref="clickPosition"
              class="page-setting-input"
              size="mini"
              controls-position="right"
              placeholder="请填写页码"
              :disabled="zsfwDisabled"
            ></el-input-number>
            页
          </div>
        </div>
      </div>

      <div class="precision-setting-item isPublic">
        <div class="precision-setting-item-title">公开展示</div>
        <div class="precision-setting-item-content">
          <el-select class="isPublicOptions" v-model="additionalSetting.open" size="mini">
            <el-option v-for="item in isPublicOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <!-- <div class="introduction isPublic">标记为“公开展示”将有可能上架到云阅读精选案例进行展示，如书刊涉密请不要设置公开展示!</div> -->
        </div>
      </div>
      <div class="precision-setting-item page-setting">
        <div class="precision-setting-item-title page-setting-title">页面处理</div>
        <div class="precision-setting-item-content page-setting-content">
          <div class="accuracy">
            <el-radio v-model="pageHandle" :label="1">以第一页高度为准，等比例展示原版页面，内容全部单页展示。</el-radio>
          </div>
          <div class="accuracy">
            <el-radio v-model="pageHandle" :label="2">以指定页尺寸为准，等比例缩放，或拆分页面，内容双页展示。</el-radio>
          </div>
          <div>
            将特殊尺寸页面按第
            <el-input-number
              ref="clickPositionPage"
              @blur="onInputBlurPage"
              @change="changeReferer"
              class="page-setting-input"
              size="mini"
              v-model="additionalSetting.referer"
              controls-position="right"
              :min="1"
              :max="maxNum"
              placeholder="请填写指定页面页码"
            ></el-input-number>
            页的尺寸，等比例缩放调整
          </div>
        </div>
      </div>
      <div class="precision-setting-item page-setting">
        <div class="precision-setting-item-title">说明</div>
        <div class="precision-setting-item-content">
          如您上传的PDF，存在部分页面尺寸不一致的情况时，云阅读会自动进行页面拆分或缩放适配，以保证最佳的浏览效果。
        </div>
      </div>
      <div class="precision-setting-item page-setting">
        <div class="precision-setting-item-title">实例</div>
        <div class="precision-setting-item-content">
          <div>
            上传5页内容的PDF，每页尺寸如下图
            <i class="el-icon-caret-bottom"></i>
          </div>
          <img class="page-setting-img" src="@assets/imgs/page_setting_1.png" />
          <div>
            指定按照第一页尺寸进行调整，调整后的效果
            <i class="el-icon-caret-bottom"></i>
          </div>
          <img class="page-setting-img" src="@assets/imgs/page_setting_2.png" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick" type="info">取 消</el-button>
        <el-button type="primary" @click="isPublicDis">确 定</el-button>
      </span>
    </el-dialog>
    <TipDialog ref="memberDialog" :dialogOptions="memberDialogOptions"></TipDialog>
  </div>
</template>

<script>
import accuracy from '@api/accuracy'
import { isPureNum } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'

export default {
  name: 'precision',
  mixins: [compareVipRight],
  data() {
    return {
      pageHandle: 0,
      zsNum: 0,
      zswfPage: undefined,
      zsfw: 1,
      isPublicOptions: [
        {
          value: 1,
          label: '公开展示'
        },
        {
          value: 0,
          label: '不公开展示'
        }
      ],
      decryption_id: isPureNum(this.$route.query.id),
      dialogVisible: false,
      additionalSetting: this.setting,
      queryDpi: this.setting.dpi
    }
  },
  props: {
    maxNum: {
      type: Number,
      default: 9999
    },
    setting: {
      type: Object
    }
  },
  computed: {
    isPaper() {
      return this.$store.state.book.isPaper
    },
    showTotalPage() {
      return this.$store.state.book.showTotalPage
    },
    zsfwDisabled() {
      return !this.compare({ type: 'boole', key: 'displayPage' })
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    merge() {
      return this.decryption_id && (this.$store.state.config.bookObj.merge === 1 || this.$store.state.book.readModel === 2)
    }
  },
  watch: {
    setting: {
      immediate: true, // immediate选项可以开启首次赋值监听
      handler(newVal, oldVal) {
        this.additionalSetting = newVal
        if (this.additionalSetting.displayPageNo == 0) {
          this.zsfw = 1
        } else {
          this.zsfw = 0
          this.zswfPage = this.additionalSetting.displayPageNo
        }
        if (this.additionalSetting.referer == 0) {
          this.pageHandle = 1
        } else if (this.additionalSetting.referer > 0) {
          this.pageHandle = 2
        }
      }
    },
    pageHandle(val) {
      if (val == 1) {
        this.additionalSetting.referer = 0
      } else {
        this.additionalSetting.referer = 1
        this.$nextTick(() => {
          if (this.$refs.clickPositionPage) {
            this.$refs.clickPositionPage.focus()
          }
        })
      }
    }
  },
  methods: {
    radiosanbai() {
      this.zsfw = 0
      this.$nextTick(() => {
        this.$refs.clickPosition.focus()
      })
    },
    changeReferer() {
      if (this.additionalSetting.referer == 0) {
        this.pageHandle = 1
      } else if (this.additionalSetting.referer > 0) {
        this.pageHandle = 2
      }
    },
    onInputBlurPage() {
      if (this.additionalSetting.referer > this.zswfPage) {
        this.$message({
          message: '请输入小于展示范围设置的页数',
          type: 'warning'
        })
        this.$nextTick(() => {
          this.$refs.clickPositionPage.focus()
        })
      }
    },
    // 部分页数为undefined失去焦点
    onInputBlur() {
      if (this.zswfPage == undefined || this.zswfPage == 0) {
        this.zsfw = 1
        this.zswfPage = undefined
      } else if (this.zswfPage < this.additionalSetting.referer) {
        this.$message({
          message: '请输入大于页面处理设置的页数',
          type: 'warning'
        })
        this.$nextTick(() => {
          this.$refs.clickPosition.focus()
        })
      } else {
        this.zsfw = 0
      }
    },
    getAllCursor() {
      this.zswfPage = undefined
      this.zsNum = 0
    },
    // 选中部分获取焦点
    async zsfwRadioHandler(value) {
      if (value === 0) {
        if (!(await this.compareRight({ type: 'boole', key: 'displayPage' }))) {
          this.$refs.memberDialog.visible = true
          this.zsfw = 1
        } else {
          this.zswfPage = 2
          this.$nextTick(() => {
            this.$refs.clickPosition.focus()
          })
        }
      } else {
        this.$nextTick(() => {
          this.$refs.clickPosition.focus()
        })
      }
    },
    // 取消
    cancelClick() {
      this.dialogVisible = false
    },
    // 精度设置
    closePrecision() {
      const dpi = Number(this.additionalSetting.dpi)
      let isEqual = true
      this.queryDpi = this.$store.state.config.bookObj.dpi
      if (this.queryDpi == dpi) {
        isEqual = true
      } else {
        isEqual = false
      }
      //zjx 20221222 这部分代码是下面接口调用后再执行的，这里拿出来是因为DPI参数已不需要单独调用接口保存，所以就直接处理就好
      //zjx 20230106 这里加入了isPaper的判断，因为这里需要根据报刊类型不同进行不同的处理
      //如果传过来的dpi与设置的dpi相等，就什么也不做，如果不一样，就跳转到上传页面进行转换
      if (this.isPaper) {
        if (!isEqual) {
          this.$router.push({ name: 'Upload', params: { to: 'PaperUpload', id: this.decryption_id } })
        } else {
          window.localStorage.setItem('IS_TRUE', 1)
          this.$nextTick(() => {
            this.$emit('undataBookPage')
          })
        }
      } else {
        const params = {
          id: this.decryption_id,
          dpi: dpi
        }
        accuracy
          .accuracy(params)
          .then((res) => {
            let code = res.data.code
            if (code == 0) {
              //如果传过来的dpi与设置的dpi相等，就什么也不做，如果不一样，就跳转到上传页面进行转换
              if (!isEqual) {
                this.$router.push({
                  path: '/upload',
                  name: 'Upload',
                  params: {
                    to: this.isPaper ? 'PaperUpload' : 'PDFUpload',
                    id: this.decryption_id
                  }
                })
              } else {
                window.localStorage.setItem('IS_TRUE', 1)
                this.$nextTick(() => {
                  this.$emit('undataBookPage')
                })
              }
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    isPublicDis() {
      this.zsNum = this.zsfw == 0 ? (this.zswfPage > 0 ? this.zswfPage : 0) : 0
      if (this.decryption_id) {
        if (this.zswfPage > this.showTotalPage) {
          this.$message({
            message: '部分展示数应小于总页数',
            type: 'warning'
          })
        } else {
          let dpi
          if (this.additionalSetting.dpi === 'null' || this.additionalSetting.dpi === null || this.additionalSetting.dpi === undefined) {
            dpi = 180
          } else {
            dpi = this.additionalSetting.dpi
          }
          if (this.pageHandle === 1) {
            this.additionalSetting.referer = 0
          }
          let params = {
            id: this.decryption_id,
            dpi: dpi,
            open: this.additionalSetting.open,
            referer: this.additionalSetting.referer,
            displayPageNo: this.zsNum
          }
          if (this.isPaper) {
            params.layoutSource = this.additionalSetting.layoutSource
            accuracy.setEpaperParams(params).then((res) => {
              if (res && res.status === 200 && res.data.status === 0) {
                this.closePrecision()
              }
            })
          } else {
            accuracy.isPublicDis(params).then((res) => {
              if (res && res.status === 200 && res.data.code === 0) {
                this.closePrecision()
              }
            })
          }
        }
      } else {
        let dpi
        if (this.additionalSetting.dpi === 'null' || this.additionalSetting.dpi === null || this.additionalSetting.dpi === undefined) {
          dpi = 180
        } else {
          dpi = this.additionalSetting.dpi
        }
        if (this.pageHandle === 1) {
          this.additionalSetting.referer = 0
        }
        let setting = {
          dpi: dpi,
          open: this.additionalSetting.open,
          referer: this.additionalSetting.referer,
          displayPageNo: this.zsNum
        }
        this.$store.commit('config/UPDATE_ADDITIONAL_SETTING', setting)
        this.cancelClick()
      }
    }
  },
  components: {
    TipDialog
  },
  destroyed() {
    this.$store.commit('config/UPDATE_ADDITIONAL_SETTING', {
      dpi: 180,
      open: 0,
      referer: 1,
      displayPageNo: this.zsNum
    })
  }
}
</script>
<style lang="scss" scoped>
.precision-setting {
  width: 100%;
  /deep/.precision-setting-dialog {
    width: 100%;
    height: 100%;
    .el-dialog {
      width: 633px;
      .el-dialog__header {
        padding: 0 !important;
        padding-bottom: 0 !important;
        background-color: #f4f4f4;
        height: 30px;
        line-height: 30px;
        .el-dialog__title {
          font-size: 14px;
          color: #000;
        }
        .el-dialog__headerbtn {
          top: 8px !important;
        }
      }
      .el-dialog__footer {
        .dialog-footer {
          .el-button {
            line-height: 0 !important;
          }
          .el-button--info {
            width: 78px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            color: #fff;
            font-size: 14px;
          }
          .el-button--primary {
            width: 78px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            color: #fff;
            font-size: 14px;
          }
        }
      }
      .el-dialog__body {
        padding-right: 40px;
      }
    }
  }
  .precision-setting-item {
    display: flex;
    margin-bottom: 15px;
    .precision-setting-item-title {
      width: 73px;
      margin-right: 10px;
      font-weight: bold;
      text-align: right;
      &.page-setting-title {
        line-height: 30px;
      }
      &.vip {
        display: inline-flex;
        flex-direction: column;
        .sub {
          height: 30px;
          &.vip-sub {
            line-height: 30px;
          }
        }
      }
    }
    .precision-setting-item-content {
      flex: 1;
      .introduction {
        font-size: 14px;
        color: #df5813;
        &.isPublic {
          margin-top: 6px;
        }
      }
      .accuracy {
        height: 30px;
      }
      &.page-setting-content {
        margin-top: 2px;
        /deep/ .page-setting-input {
          width: 179px !important;
        }
      }
      .page-setting-img {
        width: 485px;
        margin-left: -10px;
      }
    }
  }
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #000;
}

// /deep/ .el-select-dropdown.el-popper {
//   z-index: 10001 !important;
// }
</style>
